import { createContext } from "react";

export const defaultSspContextValue = {
  navigationActive: false,
};

export const SspContext = createContext(defaultSspContextValue);
